export var ActionName = {
  SUBMIT_REVIEW_FORM: 'SUBMIT_REVIEW_FORM',
  SUBMIT_RESERVATION_FORM: 'SUBMIT_RESERVATION_FORM',
  SUBMIT_CONTACT_FORM: 'SUBMIT_CONTACT_FORM',
  ANNOTATE_MENU_ITEM: 'ANNOTATE_MENU_ITEM',
  SUBMIT_SUBSCRIBE_FORM: 'SUBMIT_SUBSCRIBE_FORM'
};